import { APP_DOWNLOAD_URL } from "../config";
import { NAV_LINKS } from "../config/nav";
import { useSmoothScroll } from "./SmoothScroll";
import { Logo } from "./Navbar";

export default function Footer() {
  const scrollTo = useSmoothScroll();

  return (
    <footer className="relative border-t border-white/[0.08] bg-[#060608]" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
        <div className="grid gap-12 md:grid-cols-[1.2fr_1fr_1fr]">
          <div>
            <Logo />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-[#99A1AF]">
              Invest Smarter. Earn Together. Build the Future.
            </p>
          </div>

          <div>
            <p className="font-mono text-[10px] tracking-[0.3em] text-[#636B78] uppercase">Navigate</p>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollTo?.(`#${link.id}`)}
                    data-testid={`footer-link-${link.id}`}
                    className="text-sm text-[#99A1AF] transition-colors duration-300 hover:text-white"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-mono text-[10px] tracking-[0.3em] text-[#636B78] uppercase">App</p>
            <ul className="mt-5 space-y-3">
              <li>
                <a
                  href={APP_DOWNLOAD_URL}
                  download="winter-protocol.apk"
                  data-testid="footer-download-app-link"
                  className="text-sm text-[#99A1AF] transition-colors duration-300 hover:text-white"
                >
                  Download App
                </a>
              </li>
              <li>
                <button
                  onClick={() => scrollTo?.("#download")}
                  data-testid="footer-get-started-link"
                  className="text-sm text-[#99A1AF] transition-colors duration-300 hover:text-white"
                >
                  Get Started
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 border-t border-white/[0.07] pt-8">
          <p className="max-w-4xl text-[11px] leading-relaxed text-[#636B78]" data-testid="risk-disclaimer">
            Risk Disclaimer: Digital assets and AI-managed investment products involve significant risk,
            including the possible loss of capital. Earning and payout opportunities are not guaranteed and
            depend on product terms and market conditions. Nothing on this website constitutes financial,
            investment or legal advice, nor an offer or solicitation in any jurisdiction where such activity
            would be unlawful. Always do your own research before participating.
          </p>
          <p className="mt-6 font-mono text-xs text-[#3A3F4A]">
            © 2026 Winter Protocol. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
